<footer>
  @if (systemParamsService.getLogo()()){
    <img
      [src]="systemParamsService.getLogo()()"
      alt="department logo"
      class="logo"/>
  } @else {
    <img src="./assets/light-logo.png" alt="department logo" class="logo">
  }
  <p>Copyright &copy; 2024 Australian Government - {{ systemParamsService.getName()() }} (<span
    class="environment">{{ environment() }}</span>) </p>
</footer>
